// Production URLs are defaults - override with env vars for local dev
export const config = {
  // API Configuration
  apiUrl: import.meta.env.VITE_API_URL ?? 'https://api.daycheckin.com',

  // Site Configuration
  siteName: 'DayCheckin',
  siteUrl: import.meta.env.VITE_SITE_URL ?? 'https://daycheckin.com',

  // App URLs
  appUrl: import.meta.env.VITE_APP_URL ?? 'https://app.daycheckin.com',
  signupUrl: import.meta.env.VITE_SIGNUP_URL ?? 'https://app.daycheckin.com/signup',
  loginUrl: import.meta.env.VITE_LOGIN_URL ?? 'https://app.daycheckin.com/login',
} as const;
